module.exports = __webpack_public_path__ + "static/media/prizm-road.b3172383.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-road.mp4
// module id = 3545
// module chunks = 0